import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PreviousExp.css";

function PreviousExp() {
  const [postInternship, setPostInternship] = useState(0);
  const [postGraduation, setPostGraduation] = useState(0);
  const [totalExperience, setTotalExperience] = useState(0);

  return (
    <div className="previousexp-container container mt-3">

      {/* Post Internship */}
      <div className="mb-5">
        <label className="form-label fw-bold">
          Post Internship Clinical Experience
        </label>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="previousexp-circle previousexp-current">{postInternship}</div>
          <input
            type="range"
            className="previousexp-range flex-grow-1 mx-3"
            min="0"
            max="40"
            value={postInternship}
            onChange={(e) => setPostInternship(parseInt(e.target.value))}
          />
          <div className="previousexp-circle previousexp-current">{postInternship}</div>
        </div>
      </div>

      {/* Post Graduation */}
      <div className="mb-5">
        <label className="form-label fw-bold">
          Post Graduation Clinical Experience
        </label>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="previousexp-circle previousexp-current">{postGraduation}</div>
          <input
            type="range"
            className="previousexp-range flex-grow-1 mx-3"
            min="0"
            max="40"
            value={postGraduation}
            onChange={(e) => setPostGraduation(parseInt(e.target.value))}
          />
          <div className="previousexp-circle previousexp-current">{postGraduation}</div>
        </div>
      </div>

      {/* Total Experience */}
      <div className="mb-4">
        <label className="form-label fw-bold">
          Total Years of Experience as a Doctor{" "}
          <span className="text-danger">*</span>
        </label>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="previousexp-circle previousexp-current">{totalExperience}</div>
          <input
            type="range"
            className="previousexp-range flex-grow-1 mx-3"
            min="0"
            max="40"
            value={totalExperience}
            onChange={(e) => setTotalExperience(parseInt(e.target.value))}
          />
          <div className="previousexp-circle previousexp-current">{totalExperience}</div>
        </div>
      </div>

      {/* LinkedIn */}
      <div className="mb-3">
        <select className="previousexp-select previousexp-input text-center">
          <option value="">Type your LinkedIn profile (Optional)</option>
          <option value="https://www.linkedin.com/in/user1">LinkedIn - User 1</option>
          <option value="https://www.linkedin.com/in/user2">LinkedIn - User 2</option>
          <option value="https://www.linkedin.com/in/user3">LinkedIn - User 3</option>
          <option value="custom">Other (Enter Manually)</option>
        </select>
      </div>

      {/* Current Hospital */}
      <h5 className="fw-bold mb-3">Which hospital do you currently work at?</h5>
      <div className="row g-3 mb-3">
        <div className="col-md-6">
          <input type="text" className="form-control previousexp-input" placeholder="Type your Current hospital name" />
        </div>
        <div className="col-md-6">
          <select className="form-select previousexp-input">
            <option>Select Country</option>
            <option>India</option>
            <option>USA</option>
            <option>UK</option>
          </select>
        </div>
      </div>
      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <input type="date" className="form-control previousexp-input" />
        </div>
        <div className="col-md-6">
          <input type="date" className="form-control previousexp-input" />
        </div>
      </div>

      {/* Previous Hospital */}
      <h5 className="fw-bold mb-3">Previous Hospital Name</h5>
      <div className="row g-3 mb-3">
        <div className="col-md-6">
          <input type="text" className="form-control previousexp-input" placeholder="Type your previous hospital name" />
        </div>
        <div className="col-md-6">
          <select className="form-select previousexp-input">
            <option>Select Country</option>
            <option>India</option>
            <option>USA</option>
            <option>UK</option>
          </select>
        </div>
      </div>
      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <input type="date" className="form-control previousexp-input" />
        </div>
        <div className="col-md-6">
          <input type="date" className="form-control previousexp-input" />
        </div>
      </div>

      <div className="text-end">
        <button className="previousexp-addmore">
          <span className="me-2">+</span> Add More
        </button>
      </div>
    </div>
  );
}

export default PreviousExp;
